import { render } from "./ATooltip.vue?vue&type=template&id=270b886e"
import script from "./ATooltip.vue?vue&type=script&lang=js"
export * from "./ATooltip.vue?vue&type=script&lang=js"

import "./ATooltip.vue?vue&type=style&index=0&id=270b886e&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__